import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import TextLogo from '../../../Components/TextLogo';

export const InboundHeader = ({ position = 'absolute' }) => {
	return (
		<AppBar
			position={position}
			sx={{
				height: '60px',
				backgroundColor: AppColors?.WHITE,
				color: AppColors?.BLACK,
				border: '1px solid #E6E6E6',
				boxShadow: '0px 2px 10px 0px #00000030',
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				zIndex: (theme) => theme.zIndex.drawer + 1,
			}}
		>
			<Toolbar
				sx={{
					height: '100%',
					width: '100%',
					display: 'flex',
					justifyContent: 'space-between', // This separates left and right elements
				}}
			>
				{/* Right side */}
				<Typography
					variant="h6"
					component="div"
					sx={(theme) => ({
						fontWeight: 'bold',
						fontSize: '20px',
						color: theme.palette.primary.darker_primary,
					})}
				>
					CultureOS
				</Typography>

				{/* Left side */}
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<TextLogo img />
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export default InboundHeader;
